export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4760.22355626.jpg";